import PopImg from "../assets/images/UsersPage/user-logo-pop.svg";
import RockImg from "../assets/images/UsersPage/user-logo-rock.svg";
import BalladeImg from "../assets/images/UsersPage/user-logo-ballad.svg";
import JazzImg from "../assets/images/UsersPage/user-logo-jazz.svg";
import HiphopImg from "../assets/images/UsersPage/user-logo-hiphop.svg";
import LofiImg from "../assets/images/UsersPage/user-logo-lofi.svg";
import DanceImg from "../assets/images/UsersPage/user-logo-dance.svg";
import EtcImg from "../assets/images/UsersPage/user-logo-etc.svg";

export const ProfileImg = [
  {
    id: 0,
    name: "팝",
    EngName: "POP",
    imgSrc: PopImg,
  },
  {
    id: 1,
    name: "록/메탈",
    EngName: "ROCK",
    imgSrc: RockImg,
  },
  {
    id: 2,
    name: "발라드",
    EngName: "BALLAD",

    imgSrc: BalladeImg,
  },
  {
    id: 3,
    name: "재즈",
    EngName: "JAZZ",

    imgSrc: JazzImg,
  },
  {
    id: 4,
    name: "힙합",
    EngName: "HIPHOP",

    imgSrc: HiphopImg,
  },
  {
    id: 5,
    name: "Lo-Fi",
    EngName: "LOFI",

    imgSrc: LofiImg,
  },
  {
    id: 6,
    name: "댄스",
    EngName: "DANCE",

    imgSrc: DanceImg,
  },
  {
    id: 7,
    name: "기타",
    EngName: "EXTRA",

    imgSrc: EtcImg,
  },
];
